import { useTranslation } from '../i18n';

export default function Footer() {
  const { dict } = useTranslation();
  return (
    <footer className="page-footer">
      <div className="footer-copy">
        <img
          src="https://ntq.com.vn/wp-content/themes/ntq_branding/assets/images/NTQ-logo.png"
          alt="NTQ"
          onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        />
        <span>{dict.footer_copy}</span>
      </div>
      <div className="footer-links">
        <a href="https://ntq.com.vn" target="_blank" rel="noopener">ntq.com.vn</a>
        <span>&middot;</span>
        <span>{dict.footer_version}</span>
      </div>
    </footer>
  );
}
